/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Row_Import_HintInputs */

const en_us2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From Strong or Hevy (CSV)`)
};

const pt_br2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do Strong ou do Hevy (CSV)`)
};

const es_419_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde Strong o Hevy (CSV)`)
};

const pt_pt2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do Strong ou do Hevy (CSV)`)
};

const fr_fr2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis Strong ou Hevy (CSV)`)
};

const de_de2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Strong oder Hevy (CSV)`)
};

const it_it2_history_transfer_row_import_hint = /** @type {(inputs: History_Transfer_Row_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da Strong o Hevy (CSV)`)
};

/**
* | output |
* | --- |
* | "From Strong or Hevy (CSV)" |
*
* @param {History_Transfer_Row_Import_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_row_import_hint = /** @type {((inputs?: History_Transfer_Row_Import_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Row_Import_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_row_import_hint(inputs)
	if (locale === "es-419") return es_419_history_transfer_row_import_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_row_import_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_row_import_hint(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_row_import_hint(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_row_import_hint(inputs)
	return en_us2_history_transfer_row_import_hint(inputs)
});
export { history_transfer_row_import_hint as "history-transfer.row_import_hint" }